module.exports = __webpack_public_path__ + "static/media/mkv-icon.4f55c5f0.svg";